import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

// makeStylesを使ってスタイルを定義
const useStyles = makeStyles((theme) => ({
  blue: (props) => ({
    color: "#F0F2F5",
    backgroundColor: "#00008B",
    fontSize: props.fontSize || 16, // 動的にフォントサイズを適用
    height: props.height || 32, // 動的に高さを適用
    width: props.width || 116, // 動的に幅を適用
    "&:hover": {
      backgroundColor: "#1E90FF",
      color: "#000",
    },
  }),
  red: (props) => ({
    color: "#F0F2F5",
    backgroundColor: "#F44336",
    fontSize: props.fontSize || 16, // 動的にフォントサイズを適用
    height: props.height || 32, // 動的に高さを適用
    width: props.width || 116, // 動的に幅を適用
    "&:hover": {
      backgroundColor: "#FF7961",
      color: "#000",
    },
  }),
  grey: (props) => ({
    color: "#F0F2F5",
    backgroundColor: theme.palette.grey["300"],
    fontSize: props.fontSize || 16, // 動的にフォントサイズを適用
    height: props.height || 32, // 動的に高さを適用
    width: props.width || 116, // 動的に幅を適用
    "&:hover": {
      backgroundColor: theme.palette.grey["200"],
    },
  }),
}));

export default function WithIconButton(props) {
  const classes = useStyles(props); // propsをuseStylesに渡す

  return (
    <Button
      component="label"
      variant="contained"
      startIcon={props.icon} // アイコンをpropsから指定
      disabled={props.disabled}
      onClick={props.onClick}
      className={props.color === "blue" ? classes.blue : classes.red} // classNameでスタイルを適用
    >
      {props.label}
    </Button>
  );
}
